import React from "react";
import { Snackbar, Alert, Box, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const TimeoutSnackbar = ({ open = true, countdown }) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ mb: 'var(--spacing-md)' }}
    >
      <Alert
        icon={<WarningAmberIcon />}
        severity="warning"
        variant="filled"
        sx={{
          alignItems: "center",
          bgcolor: "var(--color-warning)",
          color: "var(--color-text-inverse)",
          fontWeight: "var(--font-weight-medium)",
          px: 'var(--spacing-lg)',
          py: 'var(--spacing-md)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: "var(--shadow-xl)",
          fontSize: "var(--font-size-sm)",
          border: "1px solid var(--color-warning-light)",
          "& .MuiAlert-icon": {
            color: "var(--color-text-inverse)",
          },
        }}
      >
        <Box display="flex" alignItems="center" gap={'var(--spacing-sm)'}>
          <Typography
            variant="body2"
            sx={{
              color: "var(--color-text-inverse)",
              fontSize: "var(--font-size-sm)",
            }}
          >
            Session expired. Redirecting to login in
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "var(--font-weight-bold)",
              color: "var(--color-text-inverse)",
              fontSize: "var(--font-size-base)",
            }}
          >
            {countdown}
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default TimeoutSnackbar;
